import { createGlobalStyle } from 'styled-components'
import 'antd/dist/reset.css'

import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'

import './fonts/fonts.css'
export const GlobalStyles = createGlobalStyle`
body {
  -webkit-text-size-adjust: 100%;
  height: auto !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family:  'Segoe UI', 'Roboto', sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme.color.darkGrey};
}
button {
  border: 0;
}
a {
  text-decoration: inherit;
  background-color: transparent; /* 1 */
  -webkit-text-decoration-skip: objects; /* 2 */
}
.ant-message {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.07);
  top: 0 !important;
  .ant-message-notice {
    .ant-message-notice-content {
      box-shadow: none;
      background-color: transparent;
      padding: 0;
      width: 100%;
    }
  }
}

.ant-message-custom-content {
  display: flex;
  justify-content: center;
}

@media (max-width: ${MAX_MOBILE_WIDTH}) {
  input,
  textarea,
  select,
  input::placeholder,
  textarea::placeholder,
  .ant-select-show-search .ant-select-selection-placeholder,
  [class*='__input-container'] {
    font-size: ${variables.fontSize16} !important;
  }

  input.ant-input,
  input.ant-input::placeholder,
  .ant-input-number-input,
  .ant-picker-input > input {
    line-height: 22px !important;
  }
}

@media (max-width: 768px) {
  .cky-btn-revisit-wrapper.cky-revisit-bottom-left,
  .cky-btn-revisit-wrapper.cky-revisit-bottom-right,
  .cky-revisit-bottom-left,
  .cky-revisit-bottom-right {
    bottom: 65px !important;
  }
}
`
